import { render, staticRenderFns } from "./Namespace.vue?vue&type=template&id=74f46d1b&scoped=true&"
import script from "./Namespace.vue?vue&type=script&lang=js&"
export * from "./Namespace.vue?vue&type=script&lang=js&"
import style0 from "./Namespace.vue?vue&type=style&index=0&id=74f46d1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f46d1b",
  null
  
)

export default component.exports